module.exports = __webpack_public_path__ + "img/mobile-elbow-19_109x68.f1a2ce7e.png";